import { useEffect, useState } from 'react';

import _ from 'lodash';

import { Tracking } from '@nerdwallet/nw-client-lib';

import { AccordionItem } from '../control-panel-accordion';

type useControlPanelAccordionToggleReturn = {
  activeIndex: number;
  setActiveIndex: (e: number) => void;
};

type useControlPanelAccordionToggleProps = {
  items: AccordionItem[];
  formName: string;
  fieldName: string;
};

export const useControlPanelAccordionToggle = ({
  formName,
  fieldName,
  items,
}: useControlPanelAccordionToggleProps): useControlPanelAccordionToggleReturn => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const activeElement = items[activeIndex];
    Tracking.formOpen({
      formName,
      fieldName,
      fieldValue: _.snakeCase(activeElement.header),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeIndex]);

  return { activeIndex, setActiveIndex };
};
